import api from '../config/api';

export const listMyVipVisitors = async (params) => {
  const res = await api.get('/staff/vip-visitors', { params });
  return res.data;
};

export const createVipVisitor = async (payload) => {
  const res = await api.post('/staff/vip-visitors', payload);
  return res.data;
};

export const listInvitedVisitors = async (params) => {
  const res = await api.get('/staff/invited-visitors', { params });
  return res.data;
};